"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.markInboxMessageAsReadArgsValidator = exports.markInboxMessageAsReadArgsSchema = void 0;
var suretype_1 = require("suretype");
var common_1 = require("../common");
exports.markInboxMessageAsReadArgsSchema = suretype_1.v.object({
    // cmd: v.string().const("markInboxMessageAsRead").required(),
    inboxMessageIds: suretype_1.v.array(common_1.idSchema).maxItems(500).required(),
    value: suretype_1.v.boolean().required()
});
exports.markInboxMessageAsReadArgsValidator = (0, suretype_1.compile)(exports.markInboxMessageAsReadArgsSchema);
